var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 60 60"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M50 25v25.5a2 2 0 0 1-2 2H37.5M10 25v25.5a2 2 0 0 0 2 2h10.5M55 30l-7.5-7.5M5 30 30 5l10 10M22.5 52.5V30h15v22.5m-15 0h15M40 15V7.5h7.5v15M40 15l7.5 7.5"
  })));
};
export default SvgHome;